import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  container: {
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
  }
}));
